<template>
  <div style="height:100%;padding: 0 40px 20px 40px;">
    <h2 class="header">待办事项</h2>
    <div class="container">
      <div class="enty">
        <b style="font-size: 18px;">请输入事项</b>
        <!-- <textarea name="" id="text" v-model="inputValue" class="text"></textarea> -->
        <input type="text" v-model="inputValue" @keyup.enter="handleSubmit" class="text" />
        <button @click="handleSubmit" class="substy">提交</button>
      </div>
      <!-- <hr /> -->
      <h3 style="margin: 20px 0 10px 0;">正在进行</h3>
      <div class="waikuang">
        <div
          v-show="item.status == 0"
          v-for="(item, index) in xinzenglist"
          :key="index"
          class="listItem"
        >
          <button class="btclear marr colb" @click="changeStatusDone(index)">
            <i class="el-icon-check">事项完成</i>
          </button>
          <span style="width: 56%;display: inline-block;">{{item.todoContent}}</span>
          <span style="width: 20%;display: inline-block;">{{item.newTime}}</span>
          <!-- <span style="width: 10%;display: inline-block;">{{item.personId}}</span> -->

          <button class="btclear marl colh fr" @click="handleDelete(index)">
            <i class="el-icon-close">删除</i>
          </button>
        </div>
      </div>

      <!-- <hr /> -->
      <h3 style="margin: 20px 0 10px 0;">已经完成</h3>
      <div class="waikuang">
        <div
          v-show="item.status == 1"
          v-for="(item, index) in xinzenglist"
          :key="index"
          class="listItem"
        >
          <button class="btclear marr colb" @click="changeStatusDoing(index)">
            <i class="el-icon-refresh-left">恢复进行</i>
          </button>
          <span style="width: 56%;display: inline-block;" class="clorshanchu">{{item.todoContent}}</span>
          <span style="width: 20%;display: inline-block;" class="clorg">{{item.newTime}}</span>
          <!-- <span style="width: 10%;display: inline-block;" class="clorg">{{item.personId}}</span> -->
          <button class="btclear marl colh fr" @click="handleDelete(index)">
            <i class="el-icon-close">删除</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      inputValue: "",
      personId: "",
      list: [],
      xinzenglist: []
    };
  },
  created() {
    this.getinfo();
    this.getTodoList();
  },
  methods: {
    getinfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.personId = uesrInfo.employee_id;
    },

    getTodoList() {
      axios.post(IPConfig.IP + "/kpi-management/todo/todo.php").then(res => {
        console.log(res.data);
        if (0 == res.data.code) {
          this.xinzenglist = res.data.get_todo_List;
          for(let key in this.xinzenglist){
            //console.log(this.xinzenglist[key].todoTime);
           
            var date = new Date(this.xinzenglist[key].todoTime);
            var time1 = date.getTime();
            this.xinzenglist[key].newTime = moment(time1).format("YYYY-MM-DD HH:mm")
          }
        }
      });
    },
    handleSubmit() {
      //提交按钮
      if (!this.inputValue == "") {
        // var reg = /^[\u4E00-\u9FA5]+$/;
        // if (!reg.test(this.inputValue)) {
        //   alert("请输入全中文");
        //   return;
        // }
      } else {
        return;
      }

      var createdobj = {
        type: 1,
        content: this.inputValue,
        personId: this.personId
      };
      axios
        .post(
          IPConfig.IP + "/kpi-management/todo/todo.php",
          JSON.stringify(createdobj)
        )
        .then(res => {
          console.log(res);
          this.inputValue = "";
          this.getTodoList();
        });
    },
    changeStatusDone(index) {
      //console.log(index);
      //console.log(this.xinzenglist);
      var clickRow = this.xinzenglist[index];
      clickRow.status = 1;
      console.log(this.xinzenglist[index]);
      //更新状态
      var updateobj = {
        type: 3,
        todoId: clickRow.todoId,
        status: 1
      };
      axios
        .post(
          IPConfig.IP + "/kpi-management/todo/todo.php",
          JSON.stringify(updateobj)
        )
        .then(res => {
          //console.log(res);
        });
    },
    changeStatusDoing(index) {
      var clickRow = this.xinzenglist[index];
      clickRow.status = 0;
      //console.log(this.xinzenglist[index]);
      //更新状态
      var updateobj = {
        type: 3,
        todoId: clickRow.todoId,
        status: 0
      };
      axios
        .post(
          IPConfig.IP + "/kpi-management/todo/todo.php",
          JSON.stringify(updateobj)
        )
        .then(res => {
          //console.log(res);
        });
    },
    handleDelete(index) {
      console.log(index);
      var clickRow = this.xinzenglist[index];
      var deletedobj = {
        type: 2,
        todoId: clickRow.todoId
      };
      axios
        .post(
          IPConfig.IP + "/kpi-management/todo/todo.php",
          JSON.stringify(deletedobj)
        )
        .then(res => {
          this.getTodoList();
        });
      console.log(clickRow);
    }
  }
};
</script>

<style scoped>
.header {
  margin-top: 10px;
  height: 30px;
  line-height: 30px;
  padding: 10px;
  background: #ffac00;
  text-align: center;
  color: #141414;
}
.container {
  padding: 0 30px;
}
.text {
  width: 600px;
  height: 30px;
  outline: none;
  margin-left: 10px;
}
.substy {
  border-radius: 6px;
  background-color: #7f9d00;
  color: #ffffff;
  height: 36px;
  width: 80px;
  border: none;
  border-style: none;
  font-size: 14px;
  outline: none;
  margin-left: 10px;
}
.enty {
  margin-bottom: 20px;
  margin-top: 20px;
}
.listItem {
  list-style: none;
  padding: 10px 10px;
  border-bottom: 1px solid #cccccc;
  width: 100%;
  box-sizing: border-box;
  padding-right: 20px;
}
.btclear {
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 16px;
  cursor: pointer;
}
.marr {
  margin-right: 10px;
}
.marl {
  margin-left: 10px;
}
.colb {
  color: #09a0c4;
}
.colh {
  color: #c40916;
}
.fr {
  float: right;
}
.clorshanchu {
  color: #8e8e8e;
  text-decoration: line-through;
}
.clorg {
  color: #8e8e8e;
}
.waikuang {
  height: 260px;
  overflow-y: scroll;
}
button:hover {
  background-color: skyblue;
}
button{
  cursor: pointer;
}

</style>>


// WEBPACK FOOTER //
// src/views/todolist.vue